import React, {useMemo, useState} from 'react';

import {ConvertorFieldTypeToDataType} from 'src/components/data-types/constants';
import {FieldType} from 'src/openapi/models/FieldType';
import {ItemsType} from 'src/openapi/models/ItemsType';

import {DropdownMenu} from '@pb/kit-component-dropdown-menu';
import {Item} from '@pb/kit-component-group';
import {Input} from '@pb/kit-component-input-v2';

import {FieldName} from '../../../typedefs';

import {DataTypeList} from './data-type-list';

type Props = {
    placeholder: string,
    fieldType?: string | FieldType,
    itemsType?: string | ItemsType,
    validationHighLight: boolean,
    onChangeDataType: (value: string, name?: string, itemsType?: string) => void,
};

export const DataTypeDropdown = (props: Props) => {
    const {
        placeholder,
        onChangeDataType,
        fieldType,
        itemsType,
        validationHighLight,
    } = props;

    const [shown, setShown] = useState(false);
    const currentDataType = useMemo(() => {
        const dataType = fieldType ? ConvertorFieldTypeToDataType[fieldType as FieldType] : '';
        if ((fieldType === FieldType.ARRAY || fieldType === FieldType.ARRAY_UNIQUE) && itemsType) {
            return `${dataType}[${ConvertorFieldTypeToDataType[itemsType as FieldType]}]`;
        }
        return dataType;
    }, [fieldType, itemsType]);

    const color = !validationHighLight || currentDataType ? 'DEFAULT' : 'ERROR';

    const handler = (value: string, item?: string) => {
        if (item) {
            onChangeDataType(value, FieldName.FIELD_TYPE, item);
            return;
        }
        onChangeDataType(value, FieldName.FIELD_TYPE);
    };

    return (
        <DropdownMenu
            shown={shown}
            setShown={setShown}
            hideOnItemClick={true}
            hideOnBodyLeave={false}
            floatingFocusManagerProps={{returnFocus: false}}
            anchor={({positionRef, getAnchorProps}) => (
                <Item style={{width: '100%'}}>
                    <Input
                        ref={positionRef}
                        {...getAnchorProps()}
                        className="ellipsis"
                        name={FieldName.FIELD_TYPE}
                        value={currentDataType}
                        placeholder={placeholder}
                        readOnly={shown}
                        color={color}
                    />
                </Item>
            )}>
            <Item style={{width: '14.2rem'}}>
                <DataTypeList handler={handler}/>
            </Item>
        </DropdownMenu>
    );
};
